var render = function render(){var _vm=this,_c=_vm._self._c;return _c('component',_vm._b({},'component',_vm.pages[_vm.$route.name || 'index'],false))
}
var staticRenderFns = []

export { render, staticRenderFns }